export default "__VITE_ASSET__I1Dx6RsN__ 720w";